import { action, thunk, persist } from 'easy-peasy';
import { httpGetOptions } from 'services/options'

// Sequence number of the latest options list request.
let optionsRequest = 0

const model = {
  loading: false,
  options: [],
  setOptions: action((state, payload) => {
    state.options = [
      ...payload,
    ]
  }),
  addOption: action((state, payload) => {
    state.options = [
      ...state.options,
      payload,
      // loggedIn: true,
    ]
  }),
  getOptions: thunk(async (actions, payload) => {
    console.log("options-model.getOptions()", payload);
    actions.setLoading(true)
    // Only the latest request may set the list: an older, slower answer (e.g. for the
    // previously shown portfolio) must not overwrite it (#1409).
    const request = ++optionsRequest
    httpGetOptions(payload).then(res => {
      if (request !== optionsRequest) {
        return
      }
      console.log("getOptions:res",res);
      console.log("getOptions:actions",actions);
      actions.setOptions(res?.data?.results);
    }, error => {
      console.log("login:error",error);
    }).finally(() => {
      if (request === optionsRequest) {
        actions.setLoading(false)
      }
    })
    
  }),
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
};

export default model;